import { render, staticRenderFns } from "./parentEquipment.vue?vue&type=template&id=30c351aa&scoped=true&"
import script from "./parentEquipment.vue?vue&type=script&lang=js&"
export * from "./parentEquipment.vue?vue&type=script&lang=js&"
import style0 from "./parentEquipment.vue?vue&type=style&index=0&id=30c351aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c351aa",
  null
  
)

export default component.exports